import sectionFaqGrid05Css from '../css-snippets/section-faq-grid-05';

const html = `
<style>${sectionFaqGrid05Css}</style>
<div
  data-container="faq-grid-container-fluid-unique-id"
  data-id="unique-id"
  data-attribute="faq-grid-container-fluid"
  data-top-padding="true"
  data-bottom-padding="true"
  class="faq-grid-container-fluid"
  data-container-full-width="true"
  data-show-separator="false"
  data-show-line-color="true"
>
  <div data-attribute="faq-grid-container" class="faq-grid-container container">
    <div data-attribute="title-faq-grid" class="title-faq-grid">
      <h2 style="text-align: center">
        <strong>You have Questions?</strong>
      </h2>
      <p style="text-align: center">
        We're here to assist you. If you have any unanswered questions, please
        don't hesitate to contact us at . We're always ready to help!
      </p>
    </div>
    <div data-attribute="list-item" class="list-item">
      <div data-attribute="item-wapper" class="item-wapper">
        <div data-attribute="item-question" class="item-question">
          <div
            class="item-question-line"
            data-attribute="item-question-line"
            data-line-color="#3b866a"
            style="background-color: #3b866a"
          ></div>
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            Does this help with COPD, Asthma, Bronchitis, or the Common Cold?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-minus-icon lucide-minus"
            >
              <path d="M5 12h14" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-plus-icon lucide-plus"
            >
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            <p>
              We formulated Lignosus with the aim of supporting healthy
              respiratory and immune systems, with consideration for everyone's
              well-being. Our ingredients have undergone extensive studies in
              various settings, and we have received numerous positive feedback
              from customers who suffer from COPD, asthma, bronchitis, and other
              respiratory conditions.
            </p>
            <p>
              However, it's important to note that no supplement can make
              specific claims regarding any diagnosis. We always advise
              consulting with your doctor or pharmacist before starting any new
              dietary supplement, as they have access to your complete medical
              history and can provide personalized guidance.
            </p>
            <p>
              Your health is our priority, and we encourage open communication
              between you and your healthcare provider to ensure the best course
              of action.
            </p>
          </div>
        </div>
      </div>
      <div data-attribute="item-wapper" class="item-wapper">
        <div data-attribute="item-question" class="item-question">
          <div
            class="item-question-line"
            data-attribute="item-question-line"
            data-line-color="#008c71"
            style="background-color: #008c71"
          ></div>
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            Is it safe to take COPD and/or Asthma medications with Lignosus?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-minus-icon lucide-minus"
            >
              <path d="M5 12h14" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-plus-icon lucide-plus"
            >
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            <p>
              We understand your concern about potential interactions between
              Lignosus and your existing medications. To date, there are no
              known contraindications or adverse side effects when taking
              Lignosus at the recommended usage alongside other medications.
            </p>
            <p>
              However, it is recommended that Lignosus be taken at least 2 hours
              apart from other medications to ensure optimal absorption and
              effectiveness.
            </p>
          </div>
        </div>
      </div>
      <div data-attribute="item-wapper" class="item-wapper">
        <div data-attribute="item-question" class="item-question">
          <div
            class="item-question-line"
            data-attribute="item-question-line"
            data-line-color="#07a16e"
            style="background-color: #07a16e"
          ></div>
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            Does this help my lungs if I vape or smoke?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-minus-icon lucide-minus"
            >
              <path d="M5 12h14" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-plus-icon lucide-plus"
            >
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            <p>
              Absolutely! Lignosus is specifically formulated to support your
              lung health, even if you vape or smoke. Our carefully selected
              ingredients work together to provide natural benefits, including
              helping to clear your lungs and promote respiratory well-being.
            </p>
            <p>
              Incorporating Lignosus into your routine is a proactive step
              towards taking care of your respiratory system. We understand the
              unique challenges faced by smokers and vape users, and our product
              is designed with their lung health in mind.
            </p>
          </div>
        </div>
      </div>
      <div data-attribute="item-wapper" class="item-wapper">
        <div data-attribute="item-question" class="item-question">
          <div
            class="item-question-line"
            data-attribute="item-question-line"
            data-line-color="#44a869"
            style="background-color: #44a869"
          ></div>
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            How long does it take for this product to work?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-minus-icon lucide-minus"
            >
              <path d="M5 12h14" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-plus-icon lucide-plus"
            >
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            <p>
              While individual experiences may vary, many customers begin to
              notice positive effects within the first few days of using our
              product. However, we recommend allowing up to 6 to 8 weeks for the
              maximum effect to be achieved.
            </p>
            <p>
              During the initial consumption period, most customers typically
              notice significant improvements, including:
            </p>
            <ul>
              <li>Improved breathing</li>
              <li>Reduced itchy throat and cough.</li>
              <li>Increased energy levels</li>
              <li>Decreased nasal congestion and sinus issues</li>
              <li>Balanced mucus production</li>
              <li>Enhanced lung function</li>
            </ul>
            <p>
              Please keep in mind that everyone's response to the product may
              differ, and individual results may vary. It's important to
              maintain consistent usage as recommended to fully experience the
              potential benefits
            </p>
          </div>
        </div>
      </div>
      <div data-attribute="item-wapper" class="item-wapper">
        <div data-attribute="item-question" class="item-question">
          <div
            class="item-question-line"
            data-attribute="item-question-line"
            data-line-color="#99be74"
            style="background-color: #99be74"
          ></div>
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            Is Lignosus safe for kids?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-minus-icon lucide-minus"
            >
              <path d="M5 12h14" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-plus-icon lucide-plus"
            >
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            <p>
              Absolutely! For children between 2 to 6 years old, we recommend a
              dosage of half a sachet. For children 7 years old and above, we
              suggest consuming 1 sachet.
            </p>
            <p>
              We have received valuable feedback from numerous parents who have
              followed these dosages and observed positive results in their
              children. These include improved breathing, reduced coughing,
              increased energy levels, and overall enhanced respiratory health.
              Many parents have also reported that their kids have experienced a
              reduced reliance on their puffer or inhaler after incorporating
              Lignosus into their daily routine.
            </p>
            <p>
              Rest assured that Lignosus is purely natural, carefully formulated
              with safety in mind, and we prioritize the well-being of all our
              customers, including children.
            </p>
          </div>
        </div>
      </div>
      <div data-attribute="item-wapper" class="item-wapper">
        <div data-attribute="item-question" class="item-question">
          <div
            class="item-question-line"
            data-attribute="item-question-line"
            data-line-color="#99be74"
            style="background-color: #99be74"
          ></div>
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            Demo Table Content
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-minus-icon lucide-minus"
            >
              <path d="M5 12h14" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-plus-icon lucide-plus"
            >
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            <figure class="table" style="width: 100%">
              <table class="ck-table-resized">
                <colgroup>
                  <col style="width: 50%" />
                  <col style="width: 50%" />
                </colgroup>
                <tbody>
                  <tr>
                    <td>Supports breathing</td>
                    <td>Cleanses &amp; detoxes lungs</td>
                  </tr>
                  <tr>
                    <td>Relieves cough &amp; phlegm</td>
                    <td>Relieves nasal congestion</td>
                  </tr>
                  <tr>
                    <td>Natural COPD support</td>
                    <td>Supports healthy mucus production</td>
                  </tr>
                </tbody>
              </table>
            </figure>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
